$(function() {
  if($('.banner-image-filters').length) {
    $('.banner-image-filters').flickity({
      // options
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      imagesLoaded: true,
      wrapAround: true,
      freeScroll: true,
    });
  }

  $('.read_more_btn').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('read_more_btn--openned')
    $(this).parent().find('.read_more_text_wrap').toggleClass('read_more_text_wrap--visible');
  });

  $('.add-to-cart-ajax').on('click', function(e) {
    e.preventDefault();
    var form = $(this).parent('form');
    $.ajax({
      url: window.Shopify.routes.root + 'cart/add.js',
      dataType: 'json',
      type: 'post',
      data: form.serialize(),
      success: function(ev) {
        fetch('/cart.js', {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => response.json())
        .then((data) => {
          window.wetheme.updateCartDrawer(data)
          $('.header-content .slide-menu-cart').click();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      },
      error: function() {
        console.log('error')
      }
    });
    
  });

  $('.dropdown.mega-menu').find('.dropdown-submenu--second:first-child').addClass('active');

  $('.mega-menu-block').mouseleave(function(){
    $('.dropdown-submenu--second:first-child').addClass('active');
  });

  $('.sub-menu__block .dropdown-submenu').mouseover(function(){
    $(this).addClass('active');
  });

  $('.sub-menu__block .dropdown-submenu').mouseleave(function(){
    $(this).removeClass('active');
  });

  $('.mega-menu--image').mouseover(function(){
    $('.dropdown-submenu--second:first-child').addClass('active');
  });

  $('a[href="#startChat"]').on('click', function(e) {
    e.preventDefault();
    if(typeof Gladly !== 'undefined') {
      Gladly.show();
    }
  });

  //Contact form logic to change contact reason input value
  if (document.querySelector('[data-contact-reason-select]')) {
    const contactReasonSelect = document.querySelector('[data-contact-reason-select]');
    const contactReasonInput = document.querySelector('[data-contact-reason-input]');

    contactReasonInput.value = contactReasonSelect.value;

    contactReasonSelect.addEventListener('change', function() {
      contactReasonInput.value = contactReasonSelect.value;
    });
  }
});
